import { ref, watch } from '@vue/composition-api'
// import store from '@/store'

export default function useCalendarEventDetail(props) {
  // ------------------------------------------------
  // eventLocal
  // ------------------------------------------------
  
  console.log('[useCalendarEventDetail]',props.newsViewData);
  const eventLocal = ref(JSON.parse(JSON.stringify(props.newsViewData.value)))
  const resetEventLocal = () => {
    eventLocal.value = JSON.parse(JSON.stringify(props.newsViewData.value))
  }
  watch(props.newsViewData, () => {
    console.log('[watch][props.newsViewData]',props.newsViewData);
    resetEventLocal()
  })

  // ------------------------------------------------
  // isEventHandlerSidebarActive
  // * Clear form if sidebar is closed
  // ------------------------------------------------
  // watch(props.isEventHandlerSidebarActive, val => {
  //   // ? Don't reset event till transition is finished
  //   // if (!val) {
  //   //   setTimeout(() => {
  //   //     clearForm.value()
  //   //   }, 350)
  //   // }
  // })

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  // ------------------------------------------------
  // guestOptions
  // ------------------------------------------------

  /* eslint-disable global-require */
  
  /* eslint-enable global-require */

  return {
    eventLocal,
    resetEventLocal,

    // UI
   
  }
}
